export default __webpack_public_path__ + "static/media/live.ff4ec4e6.svg";